<template>
  <v-app id="zespri">
    <v-navigation-drawer v-if="isLogged" v-model="drawer" app clipped temporary>
      <v-list dense>
        <v-list-item link to="/dashboard" @click="drawer=false">
          <v-list-item-action>
            <v-icon>mdi-view-dashboard</v-icon>
          </v-list-item-action>
          <v-list-item-content>
            <v-list-item-title>Dashboard</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
        <v-list-item link to="/chart" @click="drawer=false">
          <v-list-item-action>
            <v-icon>timeline</v-icon>
          </v-list-item-action>
          <v-list-item-content>
            <v-list-item-title>Chart</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
        <v-list-item link to="/users" @click="drawer=false">
          <v-list-item-action>
            <v-icon>people</v-icon>
          </v-list-item-action>
          <v-list-item-content>
            <v-list-item-title>Users</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
        <v-list-item link @click="logout()">
          <v-list-item-action>
            <v-icon>logout</v-icon>
          </v-list-item-action>
          <v-list-item-content>
            <v-list-item-title>Logout</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
      </v-list>
    </v-navigation-drawer>
    <v-app-bar app clipped-left color="primary">
      <v-app-bar-nav-icon color="white" @click.stop="drawer = !drawer" v-if="isLogged" />
        <h2 class="h2-menu">Weather Dashboard Zespri</h2>
    </v-app-bar>
    <v-content>
      <router-view/>
    </v-content>
    <v-footer app color="primary">
      <a href="https://winetsrl.com"><span class="span-footer">Winet s.r.l.</span></a>
    </v-footer>
  </v-app>
</template>
<style>
  .h2-menu{
    color: #ffffff;
  }
  .span-footer{
    padding-right:.5rem;
    color: #ffffff;
  }
 .v-btn {
   min-width: 3em;
}

</style>
<script>
export default {
  props: {
    source: String
  },
  computed: {
    isLogged () {
      return this.$store.state.isLogged
    }
  },
  data: () => ({
    drawer: false
  }),
  methods: {
    logout(){
      this.$store.commit('logout')
      this.drawer = false
    }
  }
}
</script>
